import { useState } from 'react';
import './Contact.css';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    // Construir o mailto link
    const emailSubject = `Contato via Site - ${formData.name}`;
    const emailBody = `
      Nome: ${formData.name}
      Email: ${formData.email}
      
      Mensagem:
      ${formData.message}
    `;
    
    // Abrir cliente de email do usuário
    window.location.href = `mailto:decodebytestartup@gmail.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    
    // Mostrar mensagem de sucesso após um pequeno delay (simulando envio)
    setTimeout(() => {
      setSubmitStatus('success');
      // Resetar o formulário
      setFormData({
        name: '',
        email: '',
        message: ''
      });
      
      // Resetar o status após 3 segundos
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 3000);
    }, 1000);
  };

  return (
    <section className="contact" id="contato">
      <div className="container">
        <h2>Entre em Contato</h2>
        <p className="contact-subtitle">Tire suas dúvidas, solicite um orçamento ou candidate-se para trabalhar conosco</p>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-container">
              <div className="info-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <p>Recife - Pernambuco</p>
                </div>
              </div>

              <div className="info-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <p>decodebytestartup@gmail.com</p>
                </div>
              </div>
              
              <div className="info-item">
                <i className="fas fa-clock"></i>
                <div>
                  <p>Segunda a Sexta: 9h às 17h</p>
                </div>
              </div>
              
              <div className="social-icons">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/decodebyte?igsh=MTljZGNyYzNla3Jlbw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Nome"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={submitStatus === 'sending'}
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="E-mail"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={submitStatus === 'sending'}
                />
              </div>
            </div>

            <div className="form-group">
              <textarea
                id="message"
                name="message"
                placeholder="Mensagem"
                value={formData.message}
                onChange={handleChange}
                required
                rows={3}
                disabled={submitStatus === 'sending'}
              ></textarea>
            </div>

            <button 
              type="submit" 
              className={`button primary ${submitStatus === 'sending' ? 'sending' : ''}`}
              disabled={submitStatus === 'sending'}
            >
              {submitStatus === 'sending' ? 'Enviando...' : 'Enviar'}
            </button>
            
            {submitStatus === 'success' && (
              <div className="submit-success">
                <i className="fas fa-check-circle"></i>
                <p>Mensagem enviada com sucesso!</p>
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="submit-error">
                <i className="fas fa-exclamation-circle"></i>
                <p>Erro ao enviar mensagem. Tente novamente.</p>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}; 